import { render, staticRenderFns } from "./ExportarPedidoXlsx.vue?vue&type=template&id=9bbbd4ee&scoped=true&"
import script from "./ExportarPedidoXlsx.vue?vue&type=script&lang=js&"
export * from "./ExportarPedidoXlsx.vue?vue&type=script&lang=js&"
import style0 from "./ExportarPedidoXlsx.vue?vue&type=style&index=0&id=9bbbd4ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbbd4ee",
  null
  
)

export default component.exports